import React, { useEffect, Fragment, useState, useRef, useCallback, useMemo } from 'react'; //React is a JavaScript library for creating user interfaces.
import { utils } from '../../utils/Utils.js'; //Common Methods library which can reutilize common methods.
import ReactDom, { createPortal, unmountComponentAtNode } from "react-dom"; //This package serves as the entry point to the DOM and server renderers for React.
import VGPopUp from "../Controls/VGPopUp.jsx"; //Open popup when click on house call city.
import { AsyncGetLocation, GetBusinessLocation, GetHouseCallCity } from "../Utilities/BusinessData" //get House Call City API Call.
import { UserContext } from '../Definitions/UserContext.js'; //UseContext which have store common context data.
import { Map } from '../../utils/Map.js' //Google MAP ralted Common JS.
import $, { makeArray } from 'jquery'; //jQuery is a fast, small, and feature-rich JavaScript library.
import "../../VagaroComponent/Controls/multilocation.scss"; //Multilocation CSS style.
import { GetLocationFromLatLon, GetLocationPlace, GetLocationsFromSearch } from '../Utilities/LocationAPI';
import { ClosestWithID } from '../Utilities/HTMLHelpers';
import { SetPreviewCluster } from '../Utilities/WindowUtils';


const distanceURL = "merchants/mysite/distance";
const businessLabelName = "BUSINESSES";
const locationLabelName = "LOCATIONS"


export default function RenderBusinessLocation({ siteData, data, layout, layoutID, pages, isShowLogo, overrideOnChange, validLocations, IsCheckSelectFilter, IsLocationControl }: { siteData: UserContext, data: any, layout: any, layoutID: any, pages: any, isShowLogo: any, overrideOnChange?: (encBID: string, bidHash: string, vagaroURL: string) => void, validLocations?: any, IsCheckSelectFilter?: boolean, IsLocationControl: boolean }) {

    const layoutData = useMemo(()=>{

        let str = layout;
        let reverse = false;

        if(str.includes("reverse")){
            reverse = true;
            str = str.replace("reverse","");
        }

        return {layoutID:str,reversed:reverse};

    },[layout])

    const [mode, setMode] = useState(layoutID); // Go Table to chart & chart to table movement
    const [filterbusinessList, setFilterBusinessList] = useState(data); // Set filter business list based on search


    //let cookie = getCookie(locationCookie);
    //let cookieData = cookie ? JSON.parse(cookie) : null;
    let cookieData: any = null;
    //stencil design
    const [inProgress, setInProgress] = useState(true); // Loading stencil

    const clustorMarker = useRef<any>(null); //All business marker pushed in array object.

    const allmarkers = useRef<any>([]); //All business marker pushed in array object.
    const latituderef = useRef(0); // Store current latitude for a geolocation.
    const longituderef = useRef(0); // Store current longitude for a geolocation.

    const originalLat = useRef(0); // Store original latitude for a geolocation.
    const originalLon = useRef(0); // Store original longitude for a geolocation.

    const loadMap = useRef(false); // Store IsLoadMap First time.
    //const inputValue = useRef(""); // input value changes time store value for a textbox
    const inputRef = useRef<HTMLInputElement>(null); // input value changes time store value for a textbox
    const businessList = useRef(data) // Full Business List for a return API.
    const googleMapRef = useRef((window as any).mydatamapref); //Load google map object data store.
    const hideDivId = useRef([])
    const [inputStateVal, setInputStateVal] = useState(cookieData ? cookieData.SearchText : "");
    const [waterMarkText, setwaterMarkText] = useState("Business Name or Location");
    const [showFilter, setShowFilter] = useState(false);

    const [filterLoading, setFilterLoading] = useState(false);
    const IsCurrentLocation = useRef(true); //Set brower loaction is off then not show current point in map other wise show current location
    const isEditor = (window as any).isEditor; // Check for IsEditor or not.

    const isStencil = data?.isStenciled === true ? true : false; // Loading stencil
    const [glbplaceID, setglbplaceID] = useState("");
    const [isCloseClearList, setIsCloseClearList] = useState(false);

    const currentZoom = useRef(0)

    //only focus if the input is above
    const focusInputInView = () => {
        if (inputRef.current) {
            let bnds = inputRef.current.getBoundingClientRect();
            if (bnds.bottom < window.innerHeight)
                inputRef.current.focus();
        }
    }

    //Returns the most suitable array for mapping to as stencil
    const getStencilArray = () => {

        if (validLocations && validLocations.length > 0) {
            return validLocations;
        }
        else if (businessList.current && businessList.current.length > 0) {
            return businessList.current;

        }
        else if (siteData.MultilocationData && siteData.MultilocationData.length > 0) {
            return siteData.MultilocationData;
        }
        else {
            return [1, 2, 3, 4];
        }
    }

    const portalRef = useRef<HTMLElement | null>(null);

    if (!isEditor && !portalRef.current) {
        portalRef.current = document.getElementById("location-mobile-portal");
        if (!portalRef.current) {
            portalRef.current = document.createElement("div");
            portalRef.current.id = "location-mobile-portal";
            document.body.appendChild(portalRef.current);

        }

    }



    //find current location in map using geolocation.
    useEffect(() => {
        if (isStencil == false) {
            //Get Current location for latitude/longotude.
            if (!cookieData)
                Map.getCurrentPosition((latitude: any, longitude: any) => {
                    if (data != null && data.length > 0) {
                        if (IsCheckSelectFilter) {
                            data = data.filter(
                                (col: any) => {
                                    if (overrideOnChange) { // if coming from a component don't filter locations
                                        return true;
                                    }

                                    return col.isSelected === true
                                }
                            );
                        }
                        if (latitude != 0 && longitude != 0) {
                            latituderef.current = latitude;
                            longituderef.current = longitude;
                            IsCurrentLocation.current = true;
                        }
                        else {
                            latituderef.current = data[0].latitude;
                            longituderef.current = data[0].longitude;
                            IsCurrentLocation.current = false;
                        }

                        originalLat.current = latituderef.current;
                        originalLon.current = longituderef.current;

                        var objbusinessdistance = data;
                        objbusinessdistance.map((data: any, index: number) => {
                            data.all = data.businessName + " " + data.street + " " + data.streetNo + " " + data.city + " " + data.stateCode + " " + data.stateName + " " + data.zip + " " + data.distance + " " + data.alias + " " + data.nickName
                            data.fulladress = data.street + " " + data.city + " " + data.stateCode + " " + data.stateName;
                            data.isDuplicateAddress = false;
                            data.countbyrank = 1;
                            data.listIndex = (index + 1);
                            if (data.isLocationNickName) {
                                setwaterMarkText("Location");
                            }
                        });
                        objbusinessdistance = setRankForLocation(objbusinessdistance);
                        businessList.current = objbusinessdistance;

                        setFilterBusinessList(objbusinessdistance);
                        setInProgress(false);
                    }
                })
            else {
                updateLatLon(cookieData.Latitude, cookieData.Longitude, false)
            }
        }
    }, [data]);

    const setRankForLocation = (objbusinessdistance: any) => {
        let indexArray: any = [];
        let IndexRank: any = 0;
        objbusinessdistance.map((data: any, index: number) => {
            if (data.isGroupMysite) {
                if (index == 0) {
                    IndexRank = 1;
                    data.index = IndexRank;
                }
                else {
                    if (data.fulladress == objbusinessdistance[index - 1].fulladress) {
                        indexArray.push(index - 1);
                        if (index == objbusinessdistance.length - 1) {
                            indexArray.push(index);
                            indexArray.map((indexdata: any, indexarray: number) => {
                                objbusinessdistance[indexdata].index = IndexRank;
                                objbusinessdistance[indexdata].isDuplicateAddress = (indexarray == 1 ? false : true);
                                objbusinessdistance[indexdata].countbyrank = indexArray.length;
                            });
                        }
                    }
                    else {
                        if (indexArray.length > 0 && IndexRank > 0) {
                            objbusinessdistance[index - 1].index = IndexRank;
                            objbusinessdistance[index - 1].countbyrank = indexArray.length + 1;
                            indexArray.map((indexdata: any) => {
                                objbusinessdistance[indexdata].index = IndexRank;
                                objbusinessdistance[indexdata].isDuplicateAddress = true;
                                objbusinessdistance[indexdata].countbyrank = indexArray.length + 1;
                            });
                            indexArray = [];
                            IndexRank = IndexRank + 1;
                            data.index = IndexRank;
                        }
                        else {
                            IndexRank = IndexRank + 1;
                            data.index = IndexRank;
                        }
                    }
                }
            }
            else {
                data.index = data.listIndex;
                data.countbyrank = data.listIndex;
            }
        });
        return objbusinessdistance;
    }

    useEffect(() => {
        if (overrideOnChange) {

            //if the vagaro iframe is already open when we render the picker remove it.
            let frame = document.getElementById("iFrame_divVagaroIframe");
            if (frame) {

                let wrapper = frame.parentElement;
                if (wrapper) {
                    wrapper.style.height = "0";
                    wrapper.style.minHeight = "0";
                    wrapper.removeChild(frame);
                }
            }


            window.scrollTo(0, 0);//scroll to top when coming from a service/package ect
            if (!cookieData)
                GetBusinessLocation(siteData, IsLocationControl, (result: any) => {
                    Map.getCurrentPosition((latitude: any, longitude: any) => {
                        if (result != null && result.length > 0) {
                            // if (IsCheckSelectFilter) {
                            //     result = result.filter(
                            //         (col: any) => col.isSelected === true
                            //     );
                            // }
                            if (latitude != 0 && longitude != 0) {
                                latituderef.current = latitude;
                                longituderef.current = longitude;
                                IsCurrentLocation.current = true;
                            }
                            else {
                                latituderef.current = result[0].latitude;
                                longituderef.current = result[0].longitude;
                                IsCurrentLocation.current = false;
                            }

                            originalLat.current = latituderef.current;
                            originalLon.current = longituderef.current;

                            var objbusinessdistance = filterOutInvalidLocations(result);
                            objbusinessdistance.map((data: any, index: number) => {
                                data.all = data.businessName + " " + data.street + " " + data.streetNo + " " + data.city + " " + data.stateCode + " " + data.stateName + " " + data.zip + " " + data.distance + " " + data.alias + " " + data.nickName
                                data.fulladress = data.street + " " + data.city + " " + data.stateCode + " " + data.stateName;
                                data.isDuplicateAddress = false;
                                data.countbyrank = 1;
                                data.listIndex = (index + 1);
                                if (data.isLocationNickName) {
                                    setwaterMarkText("Location");
                                }
                            });
                            objbusinessdistance = setRankForLocation(objbusinessdistance);
                            businessList.current = objbusinessdistance;

                            setFilterBusinessList(objbusinessdistance);
                            setInProgress(false);
                        }
                    })
                }, (data: any) => { window.alert("Unable to get business location data. Please reload and try again") });
        }
    }, []);


    // Map Move Event
    useEffect(() => {
        if (!filterbusinessList || filterbusinessList.length == 0) {
            $(".norecord").show();
        }
        else {
            $(".norecord").hide();
        }
    }, [filterbusinessList]);

    const googleMap = useRef();
    //load google map first time after not call Map API.
    useEffect(() => {
        if (loadMap.current == false && mode == 2 && isStencil == false && businessList.current.length > 0) {
            Map.loadGoogleMapScript(() => {
                loadMap.current = true;
                googleMap.current = Map.initGoogleMap(latituderef.current, longituderef.current, googleMapRef, (callbackData: any) => {
                    googleMapRef.current = callbackData.current;
                });
                if (businessList.current) {
                    var IsMovePos = false;
                    if (utils.Validate(inputRef.current?.value)) {
                        IsMovePos = true;
                    }
                    Map.drawMarker(googleMap.current, businessList.current, (IsMovePos ? false : IsCurrentLocation.current), IsMovePos, latituderef.current, longituderef.current, allmarkers.current, true, (allmark: any) => {
                        allmarkers.current = allmark;
                    }, (hideDivIds: any) => {
                        hideDivId.current = hideDivIds;
                    }, true, (rank: any) => {
                        setFilterBusinessRankData(rank)
                    }, (zoom: any) => {
                        currentZoom.current = zoom
                    }, currentZoom.current, true, false, (utils.Validate(inputRef.current?.value) ? inputRef.current?.value : ""), (clustorMark: any) => {
                        clustorMarker.current = clustorMark;
                    })
                }
                if (utils.Validate(inputStateVal)) {
                    handleInputChange(inputStateVal);
                }
            })
        }
        if (!filterbusinessList || filterbusinessList.length == 0) {
            $(".norecord").show();
        }
        else {
            $(".norecord").hide();
        }
    }, [mode, isStencil, businessList.current]);

    //component load time focus in textbox
    useEffect(() => {
        if (inputRef.current && !isEditor) {

            focusInputInView();
        }
    }, [mode]);

    const setFilterBusinessRankData = (rank: any) => {
        if (rank > 0) {
            var filterdata = businessList.current.filter(
                (col: any) => col.index == rank
            );
            setFilterBusinessList(filterdata);
        }
        else {
            setFilterBusinessList(businessList.current);
        }
    }

    const filterOutInvalidLocations = (inData: any) => {
        if (validLocations) {
            inData = inData.filter((data: any) => {
                return validLocations.findIndex((valid: any) => valid.encBIDHash == data.bidHash) > -1;
            });
        }
        return inData;
    }

    const updateLatLon = (lat: number, lon: number, isCancel: boolean) => {
        latituderef.current = lat;
        longituderef.current = lon;

        setInProgress(true);
        AsyncGetLocation(siteData, latituderef.current, longituderef.current, "", distanceURL, IsLocationControl, (data: any) => {
            setInProgress(false);
            if (IsCheckSelectFilter && !overrideOnChange) {
                data = data.filter(
                    (col: any) => col.isSelected === true
                );
            }
            var objbusinessdistance = filterOutInvalidLocations(data);
            if (objbusinessdistance) {
                objbusinessdistance.map((data: any, index: number) => {
                    data.all = data.businessName + " " + data.street + " " + data.streetNo + " " + data.city + " " + data.stateCode + " " + data.stateName + " " + data.zip + " " + data.distance + " " + data.alias + " " + data.nickName
                    data.fulladress = data.street + " " + data.city + " " + data.stateCode + " " + data.stateName;
                    data.isDuplicateAddress = false;
                    data.countbyrank = 1;
                    data.listIndex = (index + 1);
                    if (data.isLocationNickName) {
                        setwaterMarkText("Location");
                    }
                });
                objbusinessdistance = setRankForLocation(objbusinessdistance);

                businessList.current = objbusinessdistance;
                setFilterBusinessList(businessList.current);

                if (allmarkers.current && allmarkers.current.length > 0 && businessList.current) {
                    Map.RemoveAllMarker(allmarkers.current);
                    if (clustorMarker.current != null) {
                        Map.RemoveAllmarkerCluster(clustorMarker.current);
                    }
                    Map.drawMarker(googleMap.current, businessList.current, false, true, latituderef.current, longituderef.current, allmarkers.current, true, (allmark: any) => {
                        allmarkers.current = allmark;
                    }, (hideDivIds: any) => {
                        hideDivId.current = hideDivIds;
                    }, false, (rank: any) => {
                        setFilterBusinessRankData(rank)
                    }, (zoom: any) => {
                        currentZoom.current = zoom
                    }, currentZoom.current, false, isCancel, (utils.Validate(inputRef.current?.value) ? inputRef.current?.value : ""), (clustorMark: any) => {
                        clustorMarker.current = clustorMark;
                    });
                }
            }
        }, (error: any) => {

            setInProgress(false);
        });


    }

    const clickOutside = (e: any) => {

        if (e.target) {
            if (ClosestWithID(e.target, "loc-search-wrapper")) {

                return;
            }
            else {
                setShowFilter(false);
            }
        }

    }
    useEffect(() => {
        document.addEventListener("click", clickOutside);
        return () => {
            document.removeEventListener("click", clickOutside);
        }
    });

    //Business On click event in map view
    (window as any).handleMapURL = (encBID: any, vagaroURL: any, bidHash: any, alias: any) => {
        OpenToMultiLocationPage(vagaroURL, encBID, bidHash, alias, pages, siteData, false);
    }

    //Business On click event in list view
    const handleURL = (selectedOption: any) => {
        if (overrideOnChange) {
            if ($(".map-view-btn").length > 0) {
                $(".map-view-btn").hide();
            }
            if ($(".list-view-btn").length > 0) {
                $(".list-view-btn").hide();
            }
            overrideOnChange(selectedOption.encBID, selectedOption.bidHash, selectedOption.vagaroURL);
        }
        else {
            OpenToMultiLocationPage(selectedOption.vagaroURL, selectedOption.encBID, selectedOption.bidHash, selectedOption.alias, pages, siteData, selectedOption.isLocationNickName);
        }
    }

    //Business On click redirect to set a specific pages.


    //Business to to table to chart view
    (window as any).GoToChartView = async () => {
        setMode(2);
        $('.dvmaplocation').show();
        $('.dvlistlocation').hide();
        const isMobile = window.matchMedia("(max-width: 767px)");
        if (isMobile.matches) {
            var $containers: any = $('.dvmaplocation');
            $containers.scrollTop($containers.offset().top);

            $containers.animate({
                scrollTop: $containers.offset().top
            });
        }
        if (!isEditor) {
            setIsCloseClearList(false);
            Map.handleSearch((utils.Validate(inputRef.current?.value) ? inputRef.current?.value : ""), googleMap.current, allmarkers.current);
            if (isCloseClearList && utils.Validate(inputRef.current?.value) == false) {
                Map.fitBound(googleMap.current, latituderef.current, longituderef.current, allmarkers.current);
            }
        }
    }

    //Business to to chart to table view
    (window as any).GoToTableView = async () => {
        setMode(1);
        $('.dvmaplocation').hide();
        $('.dvlistlocation').show();
        const isMobile = window.matchMedia("(max-width: 767px)");
        if (isMobile.matches) {
            var $containers: any = $('.dvlistlocation');
            $containers.scrollTop($containers.offset().top);

            $containers.animate({
                scrollTop: $containers.offset().top
            });
        }
    }

    // Ishow Logo As per Editor changes.
    (window as any).IsShowLogo = (isShowLogo: any) => {
        let isShowLogoElementsList = document.querySelectorAll('.isShowLogo');
        if (isShowLogo == "true") {
            isShowLogoElementsList.forEach((element: any) => {
                element.style.display = "block";
            });
        }
        else {
            isShowLogoElementsList.forEach((element: any) => {
                element.style.display = "none";
            });
        }
    }

    //searching text for filter data in businessList ref object & marker refresh data.
    const handleInputChange = (value: string) => {
        if (inputStateVal != value) {
            setInputStateVal(value);

        }
        if (inputRef.current && inputRef.current?.value != value) {
            inputRef.current.value = value;
        }
    };

    //clear button click event and markerv refresh.
    const clearInputValue = () => {
        setInputStateVal("");
        setFilterBusinessList(businessList.current);
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.focus();
        }
        setglbplaceID("");
        Map.getCurrentPosition((latitude: any, longitude: any) => {
            updateLatLon(latitude, longitude, true);
        })
        if(mode == 1) {
            setIsCloseClearList(true);
        }
    }

    //Access Location Message Close Event.
    const PopupClose = () => {
        let dom = document.getElementById("OpenDialog");
        if (dom) unmountComponentAtNode(dom);

    };

    //Access Location Message Open Event.
    const AccessLocationMessage = (title: string, body: string) => {
        return ReactDom.render(
            <VGPopUp
                id={"Alert"}
                show={true}
                onHide={PopupClose}
                title={title}
                dialogClassName="vgn-popup vgn-modal-alert vgn-modal-small"
                body={<div>
                    {body}
                </div>}
                footer={<Fragment>
                    <button className="v-button secondary invisible-button w-25" onClick={() => PopupClose()}>Close</button>
                </Fragment >}
                isRemoveTabModalIndex={false}
                isShowFooter={true}
                backdrop={true}
            />,
            document.getElementById("OpenDialog")
        );
    }

    return (
        <Fragment>
            {
                isEditor && <style>{`.canvas .multi-business-details-padding > *{pointer-events:none!important}`}</style>
            }
            <div className='select-location-title'><h3>Select location</h3></div>
            <div className='search-location-header'>
                <div id={"loc-search-wrapper"} className={mode == 1 ? 'select-location-input ' + (isStencil ? "stenciled" : "") : "select-location-input select-location-input-icon " + (isStencil ? "stenciled" : "")}>
                    <div className='select-location-input-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                            <path d="M15.7656 14.6738C16.0586 14.9668 16.0586 15.4062 15.7656 15.6699C15.6484 15.8164 15.4727 15.875 15.2969 15.875C15.0918 15.875 14.916 15.8164 14.7695 15.6699L10.8438 11.7441C9.78906 12.5938 8.4707 13.0625 7.06445 13.0625C3.72461 13.0625 1 10.3379 1 6.96875C1 3.62891 3.69531 0.875 7.06445 0.875C10.4043 0.875 13.1582 3.62891 13.1582 6.96875C13.1582 8.4043 12.6895 9.72266 11.8398 10.748L15.7656 14.6738ZM2.40625 6.96875C2.40625 9.57617 4.48633 11.6562 7.09375 11.6562C9.67188 11.6562 11.7812 9.57617 11.7812 6.96875C11.7812 4.39062 9.67188 2.28125 7.09375 2.28125C4.48633 2.28125 2.40625 4.39062 2.40625 6.96875Z" fill="#A2A0A2" />
                        </svg>
                    </div>
                    <input ref={inputRef}
                        className='stencil-item'
                        onClick={() => {
                            setShowFilter(true)
                        }}
                        type='text' defaultValue={inputStateVal} placeholder={waterMarkText} onChange={(e) => {
                            handleInputChange(e.target.value);
                            if (!showFilter) { setShowFilter(true) }

                        }}
                    ></input>
                    {inputStateVal.length > 0 &&
                        <div className='search-remove-icon' onClick={() => clearInputValue()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </div>
                    }
                    {(showFilter || filterLoading) && <LocationFilterDropdown
                        reversed={layoutData.reversed}
                        setProcessing={setInProgress}
                        onSelectBusiness={(value: any) => { handleURL(value) }}
                        businessList={businessList.current}
                        setLatLon={(lat: number, lon: number) => { updateLatLon(lat, lon, false) }}
                        userContext={siteData}
                        input={inputStateVal}
                        isLoading={filterLoading}
                        onSelect={(value: string) => { handleInputChange(value); setShowFilter(false) }}
                        onSelectCurrent={
                            () => {
                                setInProgress(true);
                                setShowFilter(false);
                                const onError = () => {
                                    setInProgress(false);
                                    window.alert("Unable to get current location. Please check your browser settings and try again.");
                                }

                                if (typeof navigator != 'undefined' && typeof navigator != null &&
                                    typeof navigator.geolocation != 'undefined' && navigator.geolocation != null) {
                                    if (typeof navigator.permissions != 'undefined' && navigator.permissions != null) {
                                        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {

                                            if (result.state == 'denied') {
                                                AccessLocationMessage("Location", "Allow access to Location Services to get your current location.")
                                                setFilterLoading(false);
                                                setInProgress(false);
                                            }
                                            else if (originalLat.current && originalLon.current) {
                                                GetLocationFromLatLon(siteData, originalLat.current.toString(), originalLon.current.toString(), (data: any) => {
                                                    if (data?.data?.data) {
                                                        let result = data.data.data;
                                                        let city = result.city;
                                                        let stateCode = result.stateCode;

                                                        let fullAddress = city + ", " + stateCode;
                                                        handleInputChange(fullAddress);
                                                        setFilterLoading(false);
                                                        setShowFilter(false);

                                                        if (originalLat.current != latituderef.current || originalLon.current != latituderef.current) {
                                                            updateLatLon(originalLat.current, originalLon.current, false);
                                                        }
                                                        setInProgress(false);
                                                    }
                                                    else {
                                                        onError();
                                                    }
                                                }, (error: any) => {
                                                    onError();
                                                });
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        place_id={glbplaceID}
                        setplace_id={setglbplaceID}
                    />}
                </div>
                {mode == 1 &&
                    <div className='map-list-icon' onClick={() => (window as any).GoToChartView()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none">
                            <path d="M26.25 0.5C26.625 0.5 27 0.828125 27 1.29688V17.5156C27 18.0781 26.5312 18.6875 26.0156 18.9219L18.9375 21.3594C18.6562 21.4531 18.2344 21.5 18 21.5C17.7188 21.5 17.2969 21.4531 17.0625 21.3594L9 18.5L0.984375 21.4531C0.890625 21.5 0.796875 21.5 0.703125 21.5C0.328125 21.5 0 21.2188 0 20.75V4.53125C0 3.96875 0.421875 3.35938 0.9375 3.125L8.01562 0.6875C8.34375 0.59375 8.67188 0.5 8.95312 0.5C9.23438 0.546875 9.65625 0.59375 9.9375 0.6875L18 3.5L25.9688 0.59375C26.0625 0.546875 26.1562 0.5 26.25 0.5ZM10.5 3.26562V16.6719L16.5 18.7812V5.375L10.5 3.26562ZM2.25 18.6406L8.20312 16.3906H8.25V2.98438L2.25 5.09375V18.6406ZM24.75 16.9531V3.40625L18.75 5.65625V19.0625L24.75 16.9531Z" fill="currentColor" />
                        </svg>
                    </div>
                }
                {mode == 2 &&
                    <div className='map-list-icon' onClick={() => (window as any).GoToTableView()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
                            <path d="M3.625 0.25C4.23438 0.25 4.75 0.765625 4.75 1.375V3.625C4.75 4.28125 4.23438 4.75 3.625 4.75H1.375C0.71875 4.75 0.25 4.28125 0.25 3.625V1.375C0.25 0.765625 0.71875 0.25 1.375 0.25H3.625ZM22.375 1.375C22.9844 1.375 23.5 1.89062 23.5 2.5C23.5 3.15625 22.9844 3.625 22.375 3.625H8.125C7.46875 3.625 7 3.15625 7 2.5C7 1.89062 7.46875 1.375 8.125 1.375H22.375ZM22.375 8.875C22.9844 8.875 23.5 9.39062 23.5 10C23.5 10.6562 22.9844 11.125 22.375 11.125H8.125C7.46875 11.125 7 10.6562 7 10C7 9.39062 7.46875 8.875 8.125 8.875H22.375ZM22.375 16.375C22.9844 16.375 23.5 16.8906 23.5 17.5C23.5 18.1562 22.9844 18.625 22.375 18.625H8.125C7.46875 18.625 7 18.1562 7 17.5C7 16.8906 7.46875 16.375 8.125 16.375H22.375ZM0.25 8.875C0.25 8.26562 0.71875 7.75 1.375 7.75H3.625C4.23438 7.75 4.75 8.26562 4.75 8.875V11.125C4.75 11.7812 4.23438 12.25 3.625 12.25H1.375C0.71875 12.25 0.25 11.7812 0.25 11.125V8.875ZM3.625 15.25C4.23438 15.25 4.75 15.7656 4.75 16.375V18.625C4.75 19.2812 4.23438 19.75 3.625 19.75H1.375C0.71875 19.75 0.25 19.2812 0.25 18.625V16.375C0.25 15.7656 0.71875 15.25 1.375 15.25H3.625Z" fill="currentColor" />
                        </svg>
                    </div>

                }
            </div>
            <div className='mbl-view-only dvmaplocation' style={{ display: mode == 2 ? "block" : "none" }}>
                <div className='content-with-map view-location-list'>
                    <div id="divlocation" className={mode == 2 ? "select-location-list map-view full-width-stencil-map" : "select-location-list map-view"} onClick={() => !isEditor && (window as any).GoToChartView()}>
                        {inProgress ? <Fragment>
                            {
                                getStencilArray().map((item: any, i: number) => {

                                    if (i < 16)//only stencil first few for large multi location sites
                                        return <div className="stenciled  flex-column gap-small w-full max-100 stencil-width" key={i}>
                                            <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                            <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                            <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                        </div>

                                    else
                                        return null;
                                })

                            }
                        </Fragment> :
                            <Multilocationcontainer fullList={businessList.current} siteData={siteData} layout={layoutData.layoutID} businessList={filterbusinessList} mode={mode} handleURL={handleURL} hideDivId={hideDivId.current} isShowLogo={isShowLogo} />
                        }
                    </div>
                    <div className='current-map-section'>
                        {!loadMap ? <div>Loading...</div> : <Fragment>
                            <div
                                ref={googleMapRef}
                                id="map_canvas"
                                className='current-map-section-width'
                            />
                        </Fragment>}
                        {!isEditor && portalRef.current && mode == 2 &&
                            createPortal(
                                <div className='mobile-view-btn'>
                                    <span className='list-view-btn' onClick={() => !isEditor && (window as any).GoToTableView()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 12" fill="none">
                                            <path d="M0.4375 0.953125C0.4375 0.572266 0.730469 0.25 1.14062 0.25H12.8594C13.2402 0.25 13.5625 0.572266 13.5625 0.953125C13.5625 1.36328 13.2402 1.65625 12.8594 1.65625H1.14062C0.730469 1.65625 0.4375 1.36328 0.4375 0.953125ZM0.4375 5.64062C0.4375 5.25977 0.730469 4.9375 1.14062 4.9375H12.8594C13.2402 4.9375 13.5625 5.25977 13.5625 5.64062C13.5625 6.05078 13.2402 6.34375 12.8594 6.34375H1.14062C0.730469 6.34375 0.4375 6.05078 0.4375 5.64062ZM12.8594 11.0312H1.14062C0.730469 11.0312 0.4375 10.7383 0.4375 10.3281C0.4375 9.94727 0.730469 9.625 1.14062 9.625H12.8594C13.2402 9.625 13.5625 9.94727 13.5625 10.3281C13.5625 10.7383 13.2402 11.0312 12.8594 11.0312Z" fill="currentColor" />
                                        </svg> List
                                    </span>

                                </div>, portalRef.current)
                        }
                    </div>
                </div>

            </div>
            <div className="view-location-list dvlistlocation" style={{ display: mode == 1 ? "block" : "none" }}>
                <div className="select-location-list" onClick={() => (window as any).GoToTableView()}>
                    {inProgress ? <Fragment>

                        {getStencilArray().map((item: any, i: number) => {

                            if (i < 16)//only stencil first few for large multi location sites
                                return <div key={i} className="stenciled  flex-column gap-small w-full max-100 stencil-width">
                                    <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                    <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                    <div className='w-full stencil-item data-progress'>&nbsp;</div>
                                </div>

                            else
                                return null;
                        })}
                    </Fragment> :
                        <Multilocationcontainer fullList={businessList.current} siteData={siteData} layout={layoutData.layoutID} businessList={businessList.current} mode={mode} handleURL={handleURL} hideDivId={hideDivId.current} isShowLogo={isShowLogo} />
                    }
                </div>
                {!isEditor && portalRef.current && mode != 2 && createPortal(
                    <div className='mobile-view-btn'>
                        <span className='map-view-btn' onClick={() => (window as any).GoToChartView()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 14" fill="none">
                                <path d="M16.9688 0.8125C17.2031 0.8125 17.4375 1.01758 17.4375 1.31055V11.4473C17.4375 11.7988 17.1445 12.1797 16.8223 12.3262L12.3984 13.8496C12.2227 13.9082 11.959 13.9375 11.8125 13.9375C11.6367 13.9375 11.373 13.9082 11.2266 13.8496L6.1875 12.0625L1.17773 13.9082C1.11914 13.9375 1.06055 13.9375 1.00195 13.9375C0.767578 13.9375 0.5625 13.7617 0.5625 13.4688V3.33203C0.5625 2.98047 0.826172 2.59961 1.14844 2.45312L5.57227 0.929688C5.77734 0.871094 5.98242 0.8125 6.1582 0.8125C6.33398 0.841797 6.59766 0.871094 6.77344 0.929688L11.8125 2.6875L16.793 0.871094C16.8516 0.841797 16.9102 0.8125 16.9688 0.8125ZM7.125 2.54102V10.9199L10.875 12.2383V3.85938L7.125 2.54102ZM1.96875 12.1504L5.68945 10.7441H5.71875V2.36523L1.96875 3.68359V12.1504ZM16.0312 11.0957V2.62891L12.2812 4.03516V12.4141L16.0312 11.0957Z" fill="currentColor" />
                            </svg> Map
                        </span>
                    </div>
                    , portalRef.current)}
            </div>
            {/* {isEditor && <div className='preview-cover' style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} onClick={(e) => e.preventDefault()}></div>} */}
        </Fragment>
    );
}


const PopupClose = () => {
    unmountComponentAtNode((window as any).document.getElementById("OpenDialog"));
};

var BName = "";
const GetHouseCallCities = (BusinessName: any, encBID: string, siteData: UserContext) => {
    BName = BusinessName;
    GetHouseCallCity(siteData, encBID, GetHouseCallCities_Success, GetHouseCallCities_OnFail)
}
const GetHouseCallCities_Success = (data: any) => {
    return ReactDom.render(
        <VGPopUp
            id={"ShowCityModal"}
            show={true}
            onHide={PopupClose}
            title={BName + "'s Service Cities"}
            dialogClassName="block-edit"
            body={
                <div className="alertContent">
                    {data.cities.map((d: any, index: number) => {
                        return <Fragment key={index}><span>{d}</span></Fragment>
                    })}
                </div>
            }
            footer={
                <Fragment>
                    <button className="v-button secondary row-gap-med invisible-button realative-posi" onClick={() => PopupClose()}>Close</button>
                </Fragment >
            }
            isRemoveTabModalIndex={false}
            isShowFooter={true}
            size={"md"}
        />,
        document.getElementById("OpenDialog"));
}
const GetHouseCallCities_OnFail = () => {
    PopupClose();
}


const Multilocationcontainer = (props: { hideDivId: any, businessList: any[], mode: any, handleURL: (data: any) => void, isShowLogo: any, layout: string, siteData: any, fullList: any[] }) => {
    var businessList = props.businessList;

    let scrollToRef = useRef(null);

    const opentab = () => {
        $(".Multilocation-genral").each(function () {
            $(this).addClass("active").addClass("active-label");
        });
    }
    useEffect(() => {
        opentab();
    }, [])

    useEffect(() => {

        if (businessList.length > 0) {
            let first = businessList[0];
            let index = props.fullList.findIndex((x: any) => x.encBID == first.encBID);

            if (index > -1) {

                let location = document.getElementById("divlocation");
                let dom = location?.children[index];
                if (location && dom) {
                    location.style.scrollBehavior = "smooth";
                    let left = dom.getBoundingClientRect().left;
                    left = left - location.getBoundingClientRect().left;
                    let offset = location.scrollLeft;
                    location.scrollLeft = -6 + left + offset;

                }

            }
        }


    }, [props.businessList])


    return (
        <Fragment>
            {props.fullList.length > 0 && props.fullList.map((data: any, index: number) => {

                let foundIndex = businessList.findIndex((x: any) => x.encBID == data.encBID);

                let divhide = [];
                if (props.mode == 2) {
                    if (utils.Validate(props.hideDivId)) {
                        divhide = props.hideDivId.filter(
                            (col: any) => col == data.index
                        );
                    }
                }

                let key = data?.alias ?? index;

                var CountryName = "";
                if (data.countryID == 2) {
                    CountryName = "United Kingdom";
                }
                else if (data.countryID == 3) {
                    CountryName = "Canada";
                }
                else if (data.countryID == 4) {
                    CountryName = "Australia";
                }
                else {
                    CountryName = "United States";
                }

                let hiddenClass = foundIndex < 0 ? "filtered-out" : "";


                // if(foundIndex<0){
                //     return <Fragment key={key}><div style={{width:"0%",height:"0%",transition:"width .2s",visibility:"hidden"}} className='filtered-out '></div></Fragment>
                // }

                return (
                    <Fragment key={key}>
                        {props.mode == 1 && props.layout == "1" &&
                            <div className={"location-box map-box" + hiddenClass}
                                onClick={(e) => { props.handleURL(data); }}>
                                <div className="d-flex">
                                    {(props.isShowLogo == "true" && data.isLocationNickName == false) && <div className="isShowLogo divMerchantImage">
                                        <span>
                                            <img src={data.cdn}></img>
                                        </span>
                                    </div>
                                    }
                                    <div className={((props.isShowLogo == "true" && data.isLocationNickName == false) ? "divLogoMarginLeft" : "divLogoMarginLeftZero")}>
                                        <div className="location-header" >
                                            <h3>{data.isGroupMysite == false && <span style={{ marginRight: "4px", marginTop: "-2px", fontWeight: "bold" }}>{(data.listIndex)}.</span>}{data.businessName + (utils.Validate(data.nickName) ? " (" + data.nickName + ")" : "")}</h3>
                                            <h3>{data.distance} {data.countryID == 1 ? <Fragment>mi</Fragment> : <Fragment>km</Fragment>}</h3>
                                        </div>
                                        {(data.isMobileServiceMandatory == 0 || data.isMobileServiceMandatory == 2) &&
                                            <a href="javascript:void(0)" className="stencil-item map-label no-a ">{data.street + (utils.Validate(data.streetNo) ? ", " + data.streetNo : "")}, {data.city}, {data.stateCode} {data.zip}</a>
                                        }
                                    </div>
                                </div>
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount > 0 &&
                                    <a href="javascript:void(0)" onClick={(e) => { e.preventDefault(); e.stopPropagation(); GetHouseCallCities(data.businessName, data.encBID, props.siteData) }} className="stencil-item map-label no-a vp-3">&nbsp; We are a Mobile Business Servicing {data.cityCount} Cities</a>
                                }
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount == 0 &&
                                    <a href="javascript:void(0)" className="stencil-item map-label no-a vp-3 not-ul">&nbsp; We are a Mobile Business Servicing Everywhere in the {CountryName}</a>
                                }
                            </div>
                        }
                        {props.mode == 1 && props.layout == "2" &&
                            <div className={"location-box map-box" + hiddenClass}
                                onClick={(e) => { props.handleURL(data); }}
                            >
                                <div className="d-flex">
                                    {(props.isShowLogo == "true" && data.isLocationNickName == false) && <div className="isShowLogo divMerchantImage">
                                        <span>
                                            <img src={data.cdn}></img>
                                        </span>
                                    </div>
                                    }
                                    <div className={((props.isShowLogo == "true" && data.isLocationNickName == false) ? "divLogoMarginLeft" : "divLogoMarginLeftZero")}>
                                        <div className="location-header"  >
                                            <h3>{data.isGroupMysite == false && <span style={{ marginRight: "4px", marginTop: "-2px", fontWeight: "bold" }}>{(data.listIndex)}.</span>}{data.street + (utils.Validate(data.streetNo) ? ", " + data.streetNo : "")}, {data.city}, {data.stateCode} {data.zip}</h3>
                                            <h3>{data.distance} {data.countryID == 1 ? <Fragment>mi</Fragment> : <Fragment>km</Fragment>}</h3>
                                        </div>
                                        {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount > 0 &&
                                            <a href="javascript:void(0)" onClick={(e) => { e.preventDefault(); e.stopPropagation(); GetHouseCallCities(data.businessName, data.encBID, props.siteData) }} className="stencil-item map-label no-a vp-3">&nbsp;We are a Mobile Business Servicing {data.cityCount} Cities</a>
                                        }
                                    </div>
                                </div>
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount == 0 &&
                                    <a href="javascript:void(0)" className="stencil-item map-label no-a vp-3 not-ul">&nbsp;We are a Mobile Business Servicing Everywhere in the {CountryName}</a>
                                }
                            </div>
                        }
                        {
                            props.mode == 2 && props.layout == "1" &&
                            <div style={{ display: (divhide.length > 0 ? "none" : "block") }} className={"location-box map-box map-div div-" + (data.index) + " " + hiddenClass}
                                onClick={(e) => { props.handleURL(data); }}
                            >
                                <div className="d-flex">
                                    {(props.isShowLogo == "true" && data.isLocationNickName == false) && <div className="isShowLogo divMerchantImage">
                                        <span>
                                            <img src={data.cdn}></img>
                                        </span>
                                    </div>
                                    }
                                    <div className={((props.isShowLogo == "true" && data.isLocationNickName == false) ? "divLogoMarginLeft" : "divLogoMarginLeftZero")}>
                                        <div className="location-header" >
                                            <h3>{data.isGroupMysite == false && <span id={"span_" + data.index} style={{ marginRight: "4px", marginTop: "-2px", fontWeight: "bold" }}>{(data.index)}.</span>}{data.businessName + (utils.Validate(data.nickName) ? " (" + data.nickName + ")" : "")}</h3>
                                            <h3>{data.distance} {data.countryID == 1 ? <Fragment>mi</Fragment> : <Fragment>km</Fragment>}</h3>
                                        </div>
                                        {(data.isMobileServiceMandatory == 0 || data.isMobileServiceMandatory == 2) &&
                                            <a href="javascript:void(0)" className="stencil-item map-label no-a">{data.street + (utils.Validate(data.streetNo) ? ", " + data.streetNo : "")}, {data.city}, {data.stateCode} {data.zip}</a>
                                        }
                                    </div>
                                </div>
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount > 0 &&
                                    <a href="javascript:void(0)" onClick={(e) => { e.preventDefault(); e.stopPropagation(); GetHouseCallCities(data.businessName, data.encBID, props.siteData) }} className="stencil-item map-label no-a vp-3">&nbsp; We are a Mobile Business Servicing {data.cityCount} Cities</a>
                                }
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount == 0 &&
                                    <a href="javascript:void(0)" className="stencil-item map-label no-a vp-3 not-ul">&nbsp; We are a Mobile Business Servicing Everywhere in the {CountryName}</a>
                                }
                            </div>
                        }
                        {
                            props.mode == 2 && props.layout == "2" &&
                            <div style={{ display: (divhide.length > 0 ? "none" : "block") }} className={"location-box map-box map-div div-" + (data.index) + " " + hiddenClass}
                                onClick={() => { props.handleURL(data); }}
                            >
                                <div className="d-flex">
                                    {(props.isShowLogo == "true" && data.isLocationNickName == false) && <div className="isShowLogo divMerchantImage">
                                        <span>
                                            <img src={data.cdn}></img>
                                        </span>
                                    </div>
                                    }
                                    <div className={((props.isShowLogo == "true" && data.isLocationNickName == false) ? "divLogoMarginLeft" : "divLogoMarginLeftZero")}>
                                        <div className="location-header" >
                                            <h3>{data.isGroupMysite == false && <span id={"span_" + data.index} style={{ marginRight: "4px", marginTop: "-2px", fontWeight: "bold" }}>{(data.index)}.</span>}{data.street + (utils.Validate(data.streetNo) ? ", " + data.streetNo : "")}, {data.city}, {data.stateCode} {data.zip}</h3>
                                            <h3>{data.distance} {data.countryID == 1 ? <Fragment>mi</Fragment> : <Fragment>km</Fragment>}</h3>
                                        </div>
                                    </div>
                                </div>
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount > 0 &&
                                    <a href="javascript:void(0)" onClick={(e) => { e.preventDefault(); e.stopPropagation(); GetHouseCallCities(data.businessName, data.encBID, props.siteData) }} className="stencil-item map-label no-a vp-3">&nbsp;We are a Mobile Business Servicing {data.cityCount} Cities</a>
                                }
                                {(data.isMobileServiceMandatory == 1 || (data.isMobileServiceMandatory == 2 && data.hasOutCallService == true)) && data.cityCount == 0 &&
                                    <a href="javascript:void(0)" className="stencil-item map-label no-a vp-3 not-ul">&nbsp;We are a Mobile Business Servicing Everywhere in the {CountryName}</a>
                                }
                            </div>
                        }


                    </Fragment>
                )
            })}

            <Fragment>
                <div className="location-box-norecords norecord" id="dvnorecord" style={{ display: "none" }}>
                    <div className="location-header map-no-record-margin">
                        <h3>No Result Found</h3>
                    </div>
                </div>
            </Fragment>
            {
                //add a buffer to allow fully scrolling to left on mobile view
            }
            <div style={{ visibility: "hidden", width: "300px", flexShrink: "0" }}></div>
        </Fragment >
    );

}

function LocationIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="1em" fill='currentColor'><path d="M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z" /></svg>
}

function PinLocationIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill='currentColor' viewBox="0 0 384 512"><path d="M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" /></svg>
}

function BusinessIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill='currentColor' viewBox="0 0 384 512"><path d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z" /></svg>
}

export function LocationFilterDropdown({reversed, setProcessing, businessList, userContext, input, onSelectBusiness, onSelect, onSelectCurrent, isLoading, setLatLon, place_id, setplace_id }: {reversed:boolean, setProcessing: (on: boolean) => void, onSelectBusiness: (item: any) => void, businessList: any[], userContext: UserContext, input: string, onSelect: (item: string) => void, onSelectCurrent: () => void, isLoading: boolean, setLatLon: (lat: number, lon: number) => void, place_id: string, setplace_id: any }) {

    const [searchloading, setSearchLoading] = useState(false);
    const searchRef = useRef<string>(""); // use reference to track delays.
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const mountedRef = useRef(true);
    useEffect(() => { return () => { mountedRef.current = false; }; }, []);
    const onKey = (e: any) => {


        if(e.key==="Enter"||e.key==="ArrowDown"||e.key==="ArrowUp"){


            if(!containerRef.current)
                return;

            e.preventDefault();
            let options = containerRef.current.querySelectorAll(".filter-item:not(.divider)");
            console.log(options);
            let index = selectedIndex;

            if (e.key === "ArrowDown") {
                index = index + 1;
            }
            else if (e.key === "ArrowUp") {
                index = index - 1;
            }

            if(index<0){
                index = 0;
            }
            if(index>=options.length){
                index = options.length-1;
            }
            //if(index!=selectedIndex){
                for(let e = 0; e<options.length;e++){
                    (options[e] as any).style.background = "";
                }
                setSelectedIndex(index);
                let optn = options[index];
                if(optn){

                    optn.scrollIntoView({block:"nearest"});
                    (optn as any).style.background = "#e0e0e0 ";
                }


            //}
            if(e.key==="Enter"){
                if(index>=0 && index<options.length){
                    let optn = options[index];
                    if(optn){

                        (optn as any).click();
                    }

                }
            }

        }
        else{
            setSelectedIndex(-1);
        }
    }



    useEffect(() => {
        if (input != searchRef.current) {
            searchRef.current = input;
            handleSearchWithDelay(input)
        }

        document.addEventListener("keydown", onKey, false);
        return () => {
            document.removeEventListener("keydown", onKey, false);
        }


    }, [input,selectedIndex])

    const handleSearchWithDelay = (searchString: string) => {

        setSearchLoading(true);

        setTimeout(() => {

            if (searchString == searchRef.current) // if user input has already changed in last 500ms, then don't call the search function
                handleSearch(searchString);

        }, 500)

    }

    const handleSearch = (searchString: string) => {

        if (input.length >= 3)
            GetLocationsFromSearch(userContext, searchString, (data: any) => {
                if (!mountedRef.current) return;
                setLocationOptions(data?.data?.data ?? []);
                setSearchLoading(false);
            }, (error: any) => {
                if (!mountedRef.current) return;
                setSearchLoading(false);
            });
        else {
            setSearchLoading(false);
        }

    }

    let listDataPush: any = [];

    const bList = (!isLoading&&input.length >= 3)?     <Fragment>
    {businessList.map((item, index) => {
        var splitval = input.split(' ');
        if (index == 0) {
            listDataPush = [];
        }
        var flag = true;
        let fullString = item.all;

        let invalid = true;

        if (input.length > 0) {
            splitval.map((splitdata, indexval) => {
                if (flag) {
                    let resultbdata = fullString.toString().toLowerCase().indexOf(splitdata.toLowerCase()) !== -1;
                    if (resultbdata) {
                        flag = true;
                    }
                    else {
                        flag = false;
                    }
                    if (flag && (indexval + 1 == splitval.length)) {
                        listDataPush.push(item);
                        invalid = false;
                    }
                }
            })
        }

        if (invalid)
            return null;

        return <Fragment key={index}>
            {
                listDataPush.length == 1 && <div className='filter-item divider flex-row gap-med drop-down-business-row'>
                    <BusinessIcon /><span className='dropdown-business-name'>{businessLabelName}</span>
                </div>
            }
            <div key={index} className='filter-item inset'
                onClick={() => { onSelectBusiness(item); }}>
                <div className='flex-column gap-med'>
                    <div>{item.businessName}</div>
                    <div>{item.city + ", " + item.stateCode}</div>
                </div>
            </div>
        </Fragment>

    })}
</Fragment>:null;




    const lList = (!isLoading&&input.length >= 3 && locationOptions.length > 0)? <Fragment>
    <div className='filter-item divider flex-row gap-med drop-down-location-row' >
        <PinLocationIcon /><span className='dropdown-location-name'>{locationLabelName}</span>
    </div>
    {locationOptions.map((item, index) => {
        let name = item.cityState;

        return <div key={index} className='filter-item inset'
            onClick={() => {
                setProcessing(true);
                setSearchLoading(true);
                onSelect(name);
                if (place_id !== item.place_id) {
                    GetLocationPlace(userContext, item.place_id, (data: any) => {
                        if (data?.data?.data) {
                            let result = data.data.data;
                            setLatLon(result.latitude, result.longitude);
                        }
                        setSearchLoading(false);
                        setplace_id(item.place_id);
                    }, (error: any) => {
                        setProcessing(false);
                        setSearchLoading(false);
                    });
                }
                else {
                    setProcessing(false);
                    setSearchLoading(false);
                }
            }}
        >{name + ", " + item.countryName}</div>
    })}
</Fragment>:null;


    return <div className='location-filter-dropdown' ref={containerRef} >
        {isLoading || searchloading ? <div className='filter-item  flex-row align-center gap-med' >{(isLoading ? "loading..." : "Searching...")}</div> :
            <Fragment>
                <div className='filter-item flex-row gap-med' style={{ color: "#0073bb" }}

                    onClick={() => { onSelectCurrent() }}
                >
                    <LocationIcon /><span className='current-location' >Current Location</span>
                </div>


                {reversed ?
                    <>
                        {bList}
                        {lList}
                    </>
                    :
                    <>
                        {lList}
                        {bList}
                    </>
                }


            </Fragment>
        }
    </div >

}


export const OpenToMultiLocationPage = (vagaroURL: string, encBID: string, bidHash: string, alias: string, pageURL: string, siteData: UserContext, isLocationNickName: boolean) => {


    if ((window as any).isEditor) {

        //no id indicates this is a address cluster, so we need to store the name of the business in the address cluster
        if (!encBID || encBID.length < 1) {
            encBID = siteData.businessId;
            bidHash = siteData.bidHash;

            SetPreviewCluster(alias.split("/").pop() ?? "");

        }

        let windowObj = window as any;
        if (windowObj.OpenPreviewLocation) {

            windowObj.OpenPreviewLocation(encBID, pageURL)
        }
        return;
    }

    if (isLocationNickName) {
        alias = encodeURIComponent(alias)
    }

    if (window.location.origin == utils.MySiteName()) {
        var url = window.location.origin;
        url = url + "/" + siteData.vgurl + "/" + alias + "/" + pageURL;
        if (url && window.location.pathname.endsWith("/preview")) {
            url = url + "/preview";
        }
        var jsonData = JSON.stringify({ vagaroURL: vagaroURL, bid: encBID, bidHash: bidHash });
        localStorage.setItem('location', jsonData);
        window.open(url, "_self");
    }
    else {
        var jsonData = JSON.stringify({ vagaroURL: vagaroURL, bid: encBID, bidHash: bidHash });
        localStorage.setItem('location', jsonData);
        window.open(window.location.origin + "/" + alias + "/" + pageURL, "_self");
    }
}